import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import _ from "lodash";
import { Knob } from "primereact/knob";
import { GlobalConstants, RouteConstants } from "../../../../constants";
import complianceImg from "../../../../assets/images/compliance.png";
import { Tooltip } from "primereact/tooltip";

const LearningJourneyCards = ({
  learningPrograms,
  getStatusProps,
  setSelectedCertificate,
  setShowPreview,
  filters = {},
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap gap-2 justify-content-center md:justify-content-start py-2">
      <Tooltip target=".custom-target-icon" />
      {(learningPrograms.filter((program) => {
        const { status } = getStatusProps(program);
        return filters.status.includes(status) || filters.status.length === 0;
      }).length > 0 &&
        learningPrograms
          .filter((program) => {
            const { status } = getStatusProps(program);
            return (
              filters.status.includes(status) || filters.status.length === 0
            );
          })
          .map((program) => {
            const endDate =
              (program.endDate &&
                dayjs
                  .utc(program.endDate)
                  .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)) ||
              null;

            const supportedLanguages =
              program.learningPathway.supportedLanguages;
            const selectedLaguages = _.sortBy(
              GlobalConstants.LANGUAGES.filter((lang) =>
                supportedLanguages.includes(lang.code)
              ).map((lang) => lang.name.match(/^([A-Za-z\s]+) \(/)[1]),
              (lang) => (lang.startsWith("English") ? "" : lang)
            );
            const { status, color } = getStatusProps(program);
            const percentage =
              program.completionCount.completedCount /
              program.completionCount.totalCount;
            return (
              <div
                className="edexlms-program-card"
                key={program.id}
                onClick={() => {
                  navigate(
                    `${RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONES.replace(
                      ":id",
                      program.id
                    )}`
                  );
                }}
              >
                <div className="edexlms-program-card-header flex justify-content-between">
                  <div
                    style={{
                      backgroundColor: color,
                      color: "white",
                      padding: "0.2rem 0.5rem",
                      borderRadius: "0.5rem",
                    }}
                    className="text-sm"
                  >
                    {intl.formatMessage({ id: status }).toUpperCase()}
                  </div>
                  {(program.endDate && (
                    <div
                      className={`flex gap-2 align-items-center ${
                        program.endDate &&
                        status !== "completed" &&
                        dayjs() > endDate
                          ? "text-red-500"
                          : ""
                      }`}
                    >
                      <i
                        className="pi pi-calendar"
                        style={{ color: "#6B7280" }}
                      ></i>
                      {endDate.format("DD MMM, YYYY")}
                    </div>
                  )) ||
                    null}
                </div>
                <div className="edexlms-program-card-title">
                  <div className="program-title">
                    {program.learningPathway.name}
                  </div>
                  <div className="program-progress">
                    <Knob
                      strokeWidth={10}
                      value={(percentage * 100).toFixed(0)}
                      valueColor="#c996fa"
                      size={45}
                      readOnly
                      valueTemplate={`${(percentage * 100).toFixed(0)}%`}
                    />
                  </div>
                </div>
                <div className="edexlms-program-banner">
                  <img
                    src={`${new URL(
                      program.learningPathway.bannerImage,
                      process.env.REACT_APP_URL
                    ).toString()}?v=${dayjs().unix()}`}
                    alt={program.learningPathway.name}
                  />
                </div>
                <div className="edexlms-program-footer">
                  <div className="flex justify-content-between">
                    <div>
                      {(program.learningPathway.type === 1 && (
                        <div className="flex justify-content-center align-items-center">
                          <img src={complianceImg} alt="compliance" />
                          <span style={{ marginLeft: "10px" }}>
                            {intl.formatMessage({ id: "compliance" })}
                          </span>
                        </div>
                      )) || <span>&nbsp;</span>}
                    </div>
                    <div>
                      <div className="edexlms-program-footer-stats">
                        <i
                          className="pi pi-users"
                          style={{ color: "#EC4899" }}
                        ></i>
                        <span>{program.totalAssignedUsers}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-content-between">
                    <div>
                      <div
                        className="edexlms-program-footer-stats"
                        style={{ marginLeft: 0 }}
                      >
                        <i
                          className="pi pi-book"
                          style={{ color: "#6B7280" }}
                        ></i>
                        <span>{program.totalLearningObjectCount}</span>
                      </div>
                    </div>
                    <div className="flex">
                      {(status === "completed" &&
                        program.learningPathway.certificateId && (
                          <div
                            className="edexlms-program-footer-stats"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedCertificate({
                                ...program.learningPathway.certificate,
                                learningName: program.learningPathway.name,
                                dateofCompletion: new Date(
                                  program.completionDate
                                ),
                              });
                              setShowPreview(true);
                              e.stopPropagation();
                            }}
                          >
                            <i
                              className="pi pi-crown"
                              style={{ color: "#6B7280" }}
                            ></i>
                            <span>Certificate</span>
                          </div>
                        )) ||
                        null}
                      <div className="edexlms-program-footer-stats">
                        <i
                          className="pi pi-language"
                          style={{ color: "#6B7280" }}
                        ></i>
                        <span
                          className={`${
                            selectedLaguages.length > 1
                              ? "custom-target-icon"
                              : ""
                          }`}
                          data-pr-tooltip={selectedLaguages.join(", ")}
                          data-pr-position="bottom"
                        >{`${selectedLaguages[0]}${
                          selectedLaguages.length > 1
                            ? ` + ${selectedLaguages.length - 1}`
                            : ""
                        }`}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })) || (
        <div>
          {intl.formatMessage({
            id: filters.status.length
              ? "no_matching_learning_programs"
              : "no_learning_programs",
          })}
        </div>
      )}
    </div>
  );
};

export default LearningJourneyCards;
